export default "/5253cd0b512a66889ef5afb5e2caf631078665a1/decc719ac0c1523cc2040d71b927dcbc.svg";